(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    /* One delegated controller, including after Shopify AJAX collection refreshes. */
(function () {
  var colorDialog = null;
  var activeCard = null;
  var lastMoreButton = null;

  function ensureDialog() {
    if (colorDialog) return colorDialog;
    colorDialog = document.createElement('dialog');
    colorDialog.className = 'ac-color-dialog';
    colorDialog.setAttribute('aria-labelledby', 'ac-color-dialog-heading');
    colorDialog.innerHTML = '<div class="ac-color-dialog-top">' +
      '<h2 class="ac-color-dialog-heading" id="ac-color-dialog-heading">Coloris</h2>' +
      '<button type="button" class="ac-color-dialog-close" data-ac-color-close aria-label="Fermer">&times;</button>' +
      '</div><div class="ac-color-dialog-grid" data-ac-color-dialog-grid></div>';
    document.body.appendChild(colorDialog);
    colorDialog.addEventListener('close', function () {
      activeCard = null;
      lastMoreButton = null;
    });
    colorDialog.addEventListener('click', function (event) {
      if (event.target !== colorDialog) return;
      var rect = colorDialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right ||
          event.clientY < rect.top || event.clientY > rect.bottom) {
        colorDialog.close();
      }
    });
    return colorDialog;
  }

  function openAllColors(trigger) {
    var card = trigger.closest('.card-wrapper');
    if (!card) return;
    var dlg = ensureDialog();
    var grid = dlg.querySelector('[data-ac-color-dialog-grid]');
    var title = dlg.querySelector('.ac-color-dialog-heading');
    grid.replaceChildren();
    title.textContent = (trigger.dataset.acDialogTitle || 'Coloris') + ' — ' + (trigger.dataset.acProductTitle || 'Produit');
    var buttons = card.querySelectorAll('.ac-variant-thumbnails [data-ac-variant-thumb]');
    var extra = card.querySelector('template[data-ac-color-extra]');

    function addButton(original) {
      var item = document.createElement('div');
      item.className = 'ac-color-dialog-item';
      var button = original.cloneNode(true);
      var img = button.querySelector('img[data-ac-lazy-src]');
      if (img) {
        img.setAttribute('src', img.dataset.acLazySrc);
        img.removeAttribute('data-ac-lazy-src');
        img.setAttribute('loading', 'lazy');
      }
      var label = document.createElement('span');
      label.className = 'ac-color-dialog-label';
      label.textContent = button.dataset.acColorName || '';
      item.appendChild(button);
      item.appendChild(label);
      if (button.dataset.acPriceText) {
        var popupPrice = document.createElement('span');
        popupPrice.className = 'ac-color-dialog-price';
        popupPrice.textContent = button.dataset.acPriceText;
        item.appendChild(popupPrice);
      }
      grid.appendChild(item);
    }

    buttons.forEach(addButton);
    if (extra) extra.content.querySelectorAll('[data-ac-variant-thumb]').forEach(addButton);
    activeCard = card;
    lastMoreButton = trigger;
    if (typeof dlg.showModal === 'function') dlg.showModal();
    else dlg.setAttribute('open', '');
  }

  function updateCardPrice(card, button) {
    var priceNode = card.querySelector('.card-information > .price');
    if (!priceNode) return;
    var priceText = button.dataset.acPriceText;
    if (!priceText) {
      var original = card.querySelector('template[data-ac-price-default]');
      if (original && original.content.firstElementChild) {
        priceNode.replaceWith(original.content.firstElementChild.cloneNode(true));
      }
      return;
    }

    var compareText = button.dataset.acPriceCompare || '';
    var price = document.createElement('div');
    price.className = 'price' + (compareText ? ' price--on-sale' : '');
    price.innerHTML = '<div class="price__container">' +
      '<div class="price__regular"><span class="visually-hidden visually-hidden--inline">Prix</span>' +
      '<span class="price-item price-item--regular" data-ac-regular-price></span></div>' +
      '<div class="price__sale"><span class="visually-hidden visually-hidden--inline">Prix habituel</span>' +
      '<span><s class="price-item price-item--regular" data-ac-compare-price></s></span>' +
      '<span class="visually-hidden visually-hidden--inline">Prix promotionnel</span>' +
      '<span class="price-item price-item--sale price-item--last" data-ac-sale-price></span>' +
      '</div></div>';
    price.querySelector('[data-ac-regular-price]').textContent = priceText;
    price.querySelector('[data-ac-compare-price]').textContent = compareText;
    price.querySelector('[data-ac-sale-price]').textContent = priceText;
    priceNode.replaceWith(price);
  }

  function saveVariantDefaultState(card) {
    if (card._acVariantDefaultState) return;
    var main = card.querySelector('.card__media img[data-ac-main-photo]');
    if (!main) return;
    var link = card.querySelector('.card__heading a.full-unstyled-link');
    var priceNode = card.querySelector('.card-information > .price');
    var pressed = [];
    card.querySelectorAll('[data-ac-variant-thumb]').forEach(function (thumb) {
      pressed.push(thumb.getAttribute('aria-pressed') || 'false');
    });
    card._acVariantDefaultState = {
      srcset: main.getAttribute('srcset') || '',
      src: main.getAttribute('src') || '',
      alt: main.getAttribute('alt') || '',
      width: main.getAttribute('width') || '',
      height: main.getAttribute('height') || '',
      link: link ? (link.getAttribute('href') || '') : '',
      priceNode: priceNode ? priceNode.cloneNode(true) : null,
      pressed: pressed
    };
  }

  function restoreVariantDefaultState(card) {
    var state = card._acVariantDefaultState;
    if (!state) return;
    var main = card.querySelector('.card__media img[data-ac-main-photo]');
    if (main) {
      main.setAttribute('srcset', state.srcset);
      main.setAttribute('src', state.src);
      main.setAttribute('alt', state.alt);
      if (state.width) main.setAttribute('width', state.width);
      if (state.height) main.setAttribute('height', state.height);
    }
    var link = card.querySelector('.card__heading a.full-unstyled-link');
    if (link && state.link) link.setAttribute('href', state.link);
    var currentPrice = card.querySelector('.card-information > .price');
    if (currentPrice && state.priceNode) currentPrice.replaceWith(state.priceNode.cloneNode(true));
    card.querySelectorAll('[data-ac-variant-thumb]').forEach(function (thumb, index) {
      thumb.setAttribute('aria-pressed', state.pressed[index] || 'false');
    });
  }

  function bindVariantPreviewReset(card) {
    if (card._acVariantResetBound) return;
    var imageZone = card.querySelector('.card__inner');
    if (imageZone) {
      imageZone.addEventListener('mouseleave', function () {
        if (!card.classList.contains('ac-variant-preview')) return;
        restoreVariantDefaultState(card);
        card.classList.remove('ac-variant-preview');
        card.classList.add('ac-image-resting');
      });
      imageZone.addEventListener('mouseenter', function () {
        if (!card.classList.contains('ac-variant-preview')) {
          card.classList.remove('ac-image-resting');
        }
      });
    }
    card.addEventListener('mouseleave', function () {
      restoreVariantDefaultState(card);
      card.classList.remove('ac-variant-preview');
      card.classList.remove('ac-image-resting');
      card._acVariantDefaultState = null;
    });
    card._acVariantResetBound = true;
  }

  function selectColor(button) {
    var card = button.closest('.card-wrapper') || activeCard;
    if (!card || !card.isConnected) return;
    var main = card.querySelector('.card__media img[data-ac-main-photo]');
    if (!main || !button.dataset.acSrc) return;
    saveVariantDefaultState(card);
    bindVariantPreviewReset(card);
    card.classList.remove('ac-image-resting');
    card.classList.add('ac-variant-preview');
    main.setAttribute('srcset', button.dataset.acSrcset || '');
    main.setAttribute('src', button.dataset.acSrc);
    main.setAttribute('alt', button.dataset.acAlt || '');
    var w = Number(button.dataset.acWidth);
    var h = Number(button.dataset.acHeight);
    if (w > 0) main.setAttribute('width', String(w));
    if (h > 0) main.setAttribute('height', String(h));
    var link = card.querySelector('.card__heading a.full-unstyled-link');
    if (link && button.dataset.acLink) link.setAttribute('href', button.dataset.acLink);
    updateCardPrice(card, button);
    var selected = button.dataset.acColorIndex;
    card.querySelectorAll('[data-ac-variant-thumb]').forEach(function (thumb) {
      thumb.setAttribute('aria-pressed', thumb.dataset.acColorIndex === selected ? 'true' : 'false');
    });
    if (colorDialog && colorDialog.open) {
      colorDialog.querySelectorAll('[data-ac-variant-thumb]').forEach(function (thumb) {
        thumb.setAttribute('aria-pressed', thumb.dataset.acColorIndex === selected ? 'true' : 'false');
      });
      colorDialog.close();
      if (lastMoreButton && lastMoreButton.isConnected) lastMoreButton.focus();
    }
  }

  function acHasDesktopHover() {
    return !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  }

  function restoreOtherInlinePreviews(cardToKeep) {
    document.querySelectorAll('.card-wrapper.ac-variant-preview').forEach(function (card) {
      if (card === cardToKeep) return;
      restoreVariantDefaultState(card);
      card.classList.remove('ac-variant-preview');
      card.classList.remove('ac-image-resting');
      card._acVariantDefaultState = null;
    });
  }

  /* Desktop: survol d'une vignette = apercu immediat.
     Mobile/tablette tactile: un toucher sur une vignette = apercu immediat.
     Sur tactile, un toucher ailleurs remet la carte dans son etat d'origine. */
  document.addEventListener('mouseover', function (event) {
    if (!acHasDesktopHover()) return;
    var target = event.target;
    if (!target || !target.closest) return;
    var thumb = target.closest('.ac-variant-thumbnails [data-ac-variant-thumb]');
    if (!thumb) return;
    if (event.relatedTarget && thumb.contains(event.relatedTarget)) return;
    selectColor(thumb);
  });

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var inlineThumb = target.closest('.ac-variant-thumbnails [data-ac-variant-thumb]');
    var dialogThumb = target.closest('.ac-color-dialog [data-ac-variant-thumb]');

    if (!acHasDesktopHover() && !inlineThumb && !dialogThumb) {
      restoreOtherInlinePreviews(null);
    }

    var more = target.closest('[data-ac-color-more]');
    if (more) {
      event.preventDefault();
      event.stopPropagation();
      openAllColors(more);
      return;
    }
    var close = target.closest('[data-ac-color-close]');
    if (close && colorDialog && colorDialog.open) {
      event.preventDefault();
      colorDialog.close();
      return;
    }
    var thumb = target.closest('[data-ac-variant-thumb]');
    if (thumb) {
      event.preventDefault();
      event.stopPropagation();
      if (thumb.closest('.ac-color-dialog')) {
        selectColor(thumb);
      } else if (!acHasDesktopHover()) {
        var card = thumb.closest('.card-wrapper');
        restoreOtherInlinePreviews(card);
        selectColor(thumb);
      }
      return;
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
